export const WaitCompleteEvent = '_wait.complete';
export const RemoveWaitEvents = '_remove.wait';